import { render, staticRenderFns } from "./CustomFieldConfig.vue?vue&type=template&id=173ed7c1&scoped=true&"
import script from "./CustomFieldConfig.vue?vue&type=script&lang=js&"
export * from "./CustomFieldConfig.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldConfig.vue?vue&type=style&index=0&id=173ed7c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ed7c1",
  null
  
)

export default component.exports